import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { Form, FormDatePicker } from "@carrotfertility/carotene-core-x"
import {
  useCheckRoutingInfoQueryCache,
  useUpdateRoutingInfo
} from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { FormattedMessage, useIntl } from "react-intl"
import { ButtonFooterLayout, ContinueButton, RoutingFlowTitle, StepLayout } from "#/components/carrot-plans/shared"
import { dayjs } from "@carrotfertility/carotene-core"
import { validateDueDate } from "#/services/common-forms"

export default function DueDateStep(): JSX.Element {
  const { mutateAsync } = useUpdateRoutingInfo()
  const routingData = useCheckRoutingInfoQueryCache()
  const defaultValue = routingData?.dueDate == null ? null : routingData?.dueDate

  const { send } = useStateMachine(defaultValue ? "" : null)
  const intl = useIntl()

  async function onClickContinue({ dueDate }: { dueDate?: dayjs.Dayjs }): Promise<void> {
    await mutateAsync({ dueDate: dueDate.format("YYYY-MM-DD") })
    send("")
  }

  const header = intl.formatMessage({
    defaultMessage: "What is your estimated due date?",
    description: "This relates to a pregnancy due date"
  })

  return (
    <>
      <RoutingFlowTitle title={header} />
      <StepLayout
        header={header}
        description={<FormattedMessage defaultMessage="This information will help us guide you to the best care." />}
        formElements={
          <>
            <Form defaultValues={{ dueDate: dayjs(defaultValue) }} onSubmit={onClickContinue}>
              <FormDatePicker
                name="dueDate"
                controllerProps={{
                  rules: {
                    required: intl.formatMessage({ defaultMessage: "Required" }),
                    validate: (value: dayjs.Dayjs) => {
                      const result = validateDueDate(value)
                      if (typeof result !== "boolean") {
                        return intl.formatMessage(result)
                      }
                      return result
                    }
                  }
                }}
                label={intl.formatMessage({
                  defaultMessage: "Due date",
                  description: "This relates to a pregnancy due date"
                })}
              />
              <ButtonFooterLayout
                continueButton={
                  <ContinueButton>
                    <FormattedMessage defaultMessage="Continue" />
                  </ContinueButton>
                }
              />
            </Form>
          </>
        }
      />
    </>
  )
}
